import api from './api';

export interface ContratoEspecial {
  id: string;
  ano: number;
  mes: number;
}

export interface ContratoEspecialTableData {
  id: string;
  indice: number;
  numeroContrato: string;
  nomeFornecedor: string;
  nomeMatriz: string;
  cnpj: string;
  codigoFornecedor: number;
  especial: boolean;
}

export const getAllContratosEspeciais = () => api.get<ContratoEspecial[]>('contratosEspeciais');
export const getContratoEspecialById = (id: string) => api.get<ContratoEspecial>(`contratosEspeciais/${id}`);
export const getDataByContratoId = (id: string) =>
  api.get<ContratoEspecialTableData[]>(`contratosEspeciais/${id}/data`);
export const updateStatusContratoEspecial = (id: string, especial: boolean) =>
  api.put<ContratoEspecialTableData>(`contratosEspeciais/${id}/`, { id, especial });
